/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youraccountisreadyyouwillberedirectedtologin9Inputs */

const en_youraccountisreadyyouwillberedirectedtologin9 = /** @type {(inputs: Youraccountisreadyyouwillberedirectedtologin9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is ready. You will be redirected to the login page shortly.`)
};

const de_youraccountisreadyyouwillberedirectedtologin9 = /** @type {(inputs: Youraccountisreadyyouwillberedirectedtologin9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto ist bereit. Du wirst gleich zur Anmeldeseite weitergeleitet.`)
};

/**
* | output |
* | --- |
* | "Your account is ready. You will be redirected to the login page shortly." |
*
* @param {Youraccountisreadyyouwillberedirectedtologin9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youraccountisreadyyouwillberedirectedtologin9 = /** @type {((inputs?: Youraccountisreadyyouwillberedirectedtologin9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youraccountisreadyyouwillberedirectedtologin9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youraccountisreadyyouwillberedirectedtologin9(inputs)
	return de_youraccountisreadyyouwillberedirectedtologin9(inputs)
});
export { youraccountisreadyyouwillberedirectedtologin9 as "yourAccountIsReadyYouWillBeRedirectedToLogin" }